import script from "./LeftRightRadar.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftRightRadar.vue?vue&type=script&setup=true&lang=js"

export default script